import { AppHelper } from "../appHelper.js";
import { AppBaseProps, CommonApp, Context, Metadata } from "../core/components/commonApp.js";
import { Grid } from "../core/components/grid.js";
import { Config } from "../core/config/config.js";
import { Helper } from "../core/util/helper.js";
import { KeyValuePair } from "../commonInterfaces.js";
import { RSplitter, RSplitterDirection } from "../core/components/rSplitter.js";
import { StocksGrid } from "./stocksGrid.js";
import { General } from "../../siteManagement/general.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { HTTPService } from "../core/util/httpManager.js";
import IncomingGoods, { IncomingGoodsProps } from "./incomingGoods.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { IsSearchField } from "../core/components/isSearchField.js";
import { TextBox } from "../core/components/textBox.js"
import React from "react";
import ReactDOM from "react-dom";

export interface ArticleFilter {
    ArtNrs: number[];
    ChargenNr: string;
    SerienNr: string;
}
export interface Warehouse {
    Id: number;
    Name: string;
    StorageSpaces: { Id: number, Name: string }[];
}
export interface StocksContext {
    stockTypes: KeyValuePair<number, string>[];
    sourceTypes: KeyValuePair<number, string>[];
    storaceSpaces: {};
    warehouses: Warehouse[]
}
interface StocksAppContext extends Context, StocksContext { }
export interface StocksProps extends AppBaseProps {
    context: StocksAppContext;
    warehouses: Warehouse[];
    incomingGoodsMetadata: Metadata;
}
interface StocksState {
    articleFilter: ArticleFilter;
    warehouses: Warehouse[];
    selectedWarehouse: number;
}
export default class Stocks extends React.Component<StocksProps, StocksState>{
    noBookmark = true;
    showIncomingGoods = true;

    private common = new AppHelper();
    private DEFAULT_SOURCE: number = 74;
    private stocksGridRef: StocksGrid;
    private sheet: Sheet;
    constructor(props: StocksProps) {
        super(props);
        this.state = {
            warehouses: JSON.parse(JSON.stringify(props.warehouses)),
            selectedWarehouse: props.warehouses[0]?.Id,
            articleFilter: {
                ArtNrs: [],
                ChargenNr: null,
                SerienNr: null
            }
        }
        this.showIncomingGoods = props.warehouses && props.warehouses.length > 0;
        this.common.enableHooks = false;
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
    }

    private loadData = async () => {
        const data = await HTTPService.post("Stock/GetWarehouses", {
            articleFilter: this.state.articleFilter
        });
        this.setState({ warehouses: data })
    }

    private renderLeftDrawer = () => {
        const leftDrawerRef = this.sheet.elements.getLeftDrawerElementRef();
        const onChange = (filter: ArticleFilter) => {
            this.setState({ articleFilter: filter }, this.loadData)
        }
        return this.props.warehouses && this.props.warehouses.length > 0 ?  ReactDOM.createPortal(<LeftDrawer onChange={onChange} />, leftDrawerRef[0]) : <></>;
    }

    startIncomingGoods = () => {
        const sheet = General.Sheet.Manager.createSheet();
        //sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
        //});
        const [warehouseId, storageSpaceId] = this.getPreselectedWarehouse();
        const props: IncomingGoodsProps = {
            context: {
                sourceTypes: this.props.context.sourceTypes,
                warehouses: this.state.warehouses,
                stockTypes: this.props.context.stockTypes
            },
            dataSources: {},
            entity: {
                IsNew: true,
                IsWatchable: true,
                IsWatched: true,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: {},
                Preselection: {
                    WarehouseId: warehouseId,
                    StorageSpaceId: storageSpaceId,
                    Source: this.DEFAULT_SOURCE,
                    State: Math.min(...this.props.context.stockTypes.map(s => s.Key)),
                    TargetAdrNr: null,
                    ProjNr: null
                },

                AdrNr: null,
                DeliveryBillId: null,

                ExecutedBy: Config.user.fullName,
                ExtecutedAt: new Date(),

                Goods: []
            },
            isWindow: false,
            metadata: this.props.incomingGoodsMetadata
        }

        sheet.show(() => {
            sheet.mountContent(IncomingGoods, props);
        });
        sheet.bind(SheetEventType.Close, async () => {
            await this.stocksGridRef.loadData();
        })
    }

    private getPreselectedWarehouse = () => {
        let storageSpaces = this.props.warehouses.find(f => f.Id == this.state.selectedWarehouse).StorageSpaces 
        if (storageSpaces.length > 0) {
            return [this.state.selectedWarehouse, storageSpaces[0].Id]
        }
        storageSpaces = this.props.warehouses[0].StorageSpaces
        return [this.props.warehouses[0].Id, storageSpaces[0].Id]

    }

    renderGrids = () => {
        return (
            <div style={{ width: "100%", height: "100%" }}>
                <RSplitter direction={RSplitterDirection.Horizontal} initialPercentage={30}>
                    <WarehousesGrid selected={this.state.selectedWarehouse} warehouses={this.state.warehouses} onSelectionChange={(selected) => { this.setState({ selectedWarehouse: selected }) }} onSheetClose={this.loadData} />
                    <StocksGrid selectedWarehouse={this.state.selectedWarehouse} context={this.props.context} ref={(ref) => { this.stocksGridRef = ref }} articleFilter={this.state.articleFilter} afterTransfer={this.loadData} />
                </RSplitter>
            </div>
        );
    }

    componentDidMount() {
        this.common.updateSheetTitle(Helper.getTranslation("WebSMS.Warehouse.Stock"))
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: () => { } });
        return (
            <>
                {this.renderLeftDrawer()}
                <CommonApp {...props} />
            </>
        );
    }
}

interface LeftDrawerProps {
    onChange: (filter: ArticleFilter) => void;
}
interface LeftDrawerState {
    articles: { text, value: number }[];
    chargenNr: string;
    serienNr: string;
}
class LeftDrawer extends React.Component<LeftDrawerProps, LeftDrawerState>{
    private factory = ComponentHelper.createFactory();
    constructor(props) {
        super(props)

        this.state = {
            articles: [],
            chargenNr: "",
            serienNr: ""
        }
    }

    private onChange = () => {
        this.props.onChange({
            ArtNrs: this.state.articles.map(a => a.value),
            ChargenNr: this.state.chargenNr,
            SerienNr: this.state.serienNr
        })
    }

    private renderArticleSearch = () => {
        const props = this.factory.getDefaultSearchFieldProps();
        props.value = this.state.articles;

        props.onChange = (_, value) => {
            this.setState({ articles: value }, this.onChange)
        }
        props.field.searchWindowUrl = "DynamicSearch/Window/Parts?fullObject=true&multi=true&displayPattern=[[bezeichnung]]"
        props.field.readOnlyTextField = true;
        props.multiSelectMode = true;
        props.field.searchTextField = "bezeichnung";
        props.field.searchValueField = "artnr";


        return this.renderField(<IsSearchField {...props} />, "BrowserTitle.Parts.Available");
    }

    private renderChargenNr = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.chargenNr;
        props.onChange = (_, value: string) => {
            this.setState({ chargenNr: value }, this.onChange)
        }
        return this.renderField(<TextBox {...props} />, "Field.Material.chargennr");
    }

    private renderSerienNr = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.serienNr;
        props.onChange = (_, value: string) => {
            this.setState({ serienNr: value }, this.onChange)
        }
        return this.renderField(<TextBox {...props} />, "Field.Material.seriennr");
    }

    private renderField = (element: JSX.Element, translationKey: string) => {
        return (
            <div style={{ display: "flex", flexDirection: "column", margin: "10px 6px 10px 0px" }}>
                <label>
                    {Helper.getTranslation(translationKey)}
                </label>
                <div style={{ marginTop: "10px" }}>
                    {element}
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
                <style>
                    {
                        `
                            div.drawer--left:not(.drawer--closed) .stocks_filter{
                                display: flex;
                                flex-direction: column;
                            }

                            div.drawer--left.drawer--closed .stocks_filter{
                                display: none;
                            }
                        `
                    }
                </style>
                <div style={{ padding: "10px" }} className="stocks_filter">
                    {this.renderArticleSearch()}
                    {/*{this.renderChargenNr()}*/}
                    {/*{this.renderSerienNr()}*/}
                </div>
            </>
        )
    }
}
interface WarehousesGridProps {
    warehouses: Warehouse[];
    onSelectionChange: (id: number) => void;
    selected: number;
    onSheetClose: () => void;
}
interface WarehouseGridState { }
class WarehousesGrid extends React.Component<WarehousesGridProps, WarehouseGridState>{
    private gridOptions: kendo.ui.GridOptions;
    constructor(props: WarehousesGridProps) {
        super(props);
        this.state = {}
        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Id",
                    title: "Id",
                    hidden: true
                },
                {
                    field: "Name",
                    title: Helper.getTranslation("Standard.Name"),
                    template: (dataItem: Warehouse) => {
                        if (Config.user.isSysAdmin) {
                            return `<a data-id="${dataItem.Id}">${dataItem.Name}</a>`
                        }
                        return dataItem.Name;
                    }
                },
                {
                    field: "Number",
                    title: Helper.getTranslation("Field.Commdocuments.documentno")
                }

            ]
        }
    }

    private openWarehouseFnc = (warehouse: Warehouse) => {
        return () => {
            const sheet = General.Sheet.Manager.createSheetWithUrl(`Warehouse/Edit?id=${warehouse.Id}`);
            sheet.bind(SheetEventType.Close, this.props.onSheetClose);
        }
    }

    private onDataBound = (e) => {
        const data: Warehouse[] = this.props.warehouses;
        for (let i = 0; i < data.length; i++) {
            const link = e.sender.tbody.find(`a[data-id="${data[i].Id}"]`);
            if (link)
                link.click(this.openWarehouseFnc(data[i]));
        }
    }

    render() {
        const onSelectionChange = (dataItem: Warehouse) => {
            if (dataItem) {
                this.setState({ selected: dataItem.Id }, () => {
                    this.props.onSelectionChange(dataItem.Id);
                })
            }
        }
        const selected = this.props.warehouses.find(f => f.Id == this.props.selected)

        return (
            <div className="flex-container">
                <Grid
                    data={this.props.warehouses}
                    options={this.gridOptions}
                    id={`stocks_warehouse`}
                    onSelectionChanged={onSelectionChange}
                    selectFilter={Helper.hasValue(selected) ? selected.Name : null}
                    preselectFilter={Helper.hasValue(selected) ? selected.Name : null}
                    onDataBound={this.onDataBound}
                />
            </div>
        )
    }
}

